var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c(
        "div",
        { staticClass: "details-view" },
        [
          _c(
            "cargo-left-right-resize",
            {
              staticStyle: { "min-height": "100%" },
              attrs: {
                "show-left": _vm.showSidebar,
                "left-style": {
                  display: "flex",
                  flex: "none",
                  minWidth: "220px"
                },
                "right-style": { display: "flex", overflow: "hidden" }
              }
            },
            [
              _c("template", { slot: "left" }, [
                _c(
                  "div",
                  { staticClass: "section", staticStyle: { flex: "1" } },
                  [
                    _c(
                      "el-scrollbar",
                      { staticStyle: { flex: "1" } },
                      [
                        _c(
                          "el-menu",
                          {
                            staticClass: "report-menu",
                            staticStyle: { flex: "1" },
                            attrs: { "default-active": _vm.activeIndex }
                          },
                          [
                            _vm._l(_vm.reports, function(report) {
                              return [
                                _c("report-sub-item", {
                                  key: report.id,
                                  attrs: { item: report },
                                  on: { click: _vm.onClick }
                                })
                              ]
                            })
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c("template", { slot: "right" }, [
                _c(
                  "div",
                  {
                    staticClass: "section",
                    staticStyle: { position: "relative", flex: "1" }
                  },
                  [
                    Boolean(_vm.selectedReport)
                      ? _c("report-item-detail", {
                          key: _vm.selectedReport.reportId,
                          attrs: {
                            "report-id": _vm.selectedReport.reportId,
                            "descriptor-registry": _vm.descriptorRegistry
                          }
                        })
                      : _c(
                          "div",
                          {
                            staticStyle: {
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              "text-align": "center",
                              transform: "translate(-50%,-50%)"
                            }
                          },
                          [
                            _c("img", {
                              attrs: {
                                width: "194",
                                height: "200",
                                src: "/static/report.png"
                              }
                            })
                          ]
                        )
                  ],
                  1
                )
              ])
            ],
            2
          )
        ],
        1
      ),
      _vm.reportDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.reportDialog.visible,
                title: _vm.$t("CargoMsg.Cargo_ExcelTemplateExport"),
                width: "700px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.reportDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "el-form",
                {
                  staticStyle: { "flex-grow": "1" },
                  attrs: { inline: true, "label-width": "100px" }
                },
                _vm._l(_vm.reportDialog.params, function(item, index) {
                  return _c("condition-form-item", {
                    key: index,
                    attrs: { item: item }
                  })
                }),
                1
              ),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c("el-button", { on: { click: _vm.runReport } }, [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Run")))
                  ]),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.reportDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "form",
        {
          ref: "form",
          staticStyle: { display: "none" },
          attrs: { action: _vm.fileUrl, target: "_blank", method: "post" }
        },
        _vm._l(_vm.fileFormEntries, function(item) {
          return _c("input", {
            key: item[0],
            attrs: { name: item[0] },
            domProps: { value: item[1] }
          })
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }